import React, { useEffect, useState } from 'react'
import jwtDecode from 'jwt-decode'
import { Link } from 'react-router-dom'
import DataTable from 'react-data-table-component'
import TableStyles from 'react-data-table-component'

import user_Store from '../store/user_store'
import student_Store from '../store/student_store'
import {
  Button,
  ButtonGroup,
  DropdownButton,
  Dropdown,
  SplitButton,
} from 'react-bootstrap'
import ExportCSV from '../functions/ExportCSV'
import Selector_Component from '../component/Selector_Component'
import supervisor_Store from '../store/supervisor_store'
import admin_Store from '../store/admin_store'
import CurrUser from '../functions/UserAuth'
import Student_Manage_Modal from '../component/Student_Manage_Modal'
import cohort_Store from '../store/cohort_store'
import major_Store from '../store/major_store'

function Student_Page() {
  // Student Store
  const student = student_Store((state) => state.student)
  // Admin Store
  const admin = admin_Store((state) => state.admin)

  const students = student_Store((state) => state.students)
  const getstudents = student_Store((state) => state.getstudents)
  const addStudent = student_Store((state) => state.addStudent)
  const putstudent = student_Store((state) => state.putstudent)
  const [page, setPage] = useState(1)
  const [totalRows, setTotalRows] = useState(0)
  const [perPage, setPerPage] = useState(10)
  const [studentId, setStudentId] = useState(-1)
  const [studentEmail, setStudentEmail] = useState('')
  const [studentCode, setStudentCode] = useState('')
  const [studentName, setStudentName] = useState('')
  // Add & Edit modal control
  const [isAdd, setIsAdd] = useState(false)
  // all majors
  const majors = major_Store((state) => state.majors)
  // get all majors
  const getMajors = major_Store((state) => state.getMajors)
  // all supervisors
  const supervisors = supervisor_Store((state) => state.supervisors)
  // get all supervisors
  const getSupervisors = supervisor_Store((state) => state.getsupervisors)
  // all cohorts
  const cohorts = cohort_Store((state) => state.cohorts)
  // get all cohorts
  const getCohorts = cohort_Store((state) => state.getCohorts)
  // student data

  let [major, setMajor] = useState([])
  let [cohort, setCohort] = useState([])
  let [supervisor, setSupervisor] = useState([])


  //  let [selectValue, setSelectValue]= useState([])
  function onSelect(actionId, id, setStatus, setClasss) {
    setStatus(actionId)
    let classvalue =
      actionId == 'Activated'
        ? 'success'
        : actionId == 'Deactivated'
          ? 'danger'
          : 'warning'
    setClasss(classvalue)
    putstudent({ status: actionId }, id)
    //   setClasss(classvalue)
  }

  const columns = [
    {
      name: 'ID',
      selector: (row, index) => index + 1,
      sortable: true,
      width: '100px',
      id: 1,
    },
    {
      name: 'Code',
      selector: (row) => row.code,
      sortable: true,
      id: 2,
    },
    {
      name: 'Email',
      selector: (row) => row.email,
      sortable: true,
      id: 3,
    },
    {
      name: 'name',
      selector: (row) => row.name,
      id: 4,
    },
    {
      name: 'major',
      selector: (row) => row?.majors?.[0]?.name ?? '',
      id: 5,
    },
    {
      name: 'cohort',
      selector: (row) => row?.cohorts?.[0]?.name ?? '',
      id: 6,
    },
    {
      name: 'advisor',
      selector: (row) => row?.supervisors?.[0]?.name ?? '',
      id: 7,
    },

    {
      name: 'Status',
      selector: (row) => row.status,
      id: 8,
    },
    {
      name: 'Edit',
      cell: (row) => {
        return (
          <button
            onClick={function () {
              edit(row.id)
            }}
            className='btn text-white bg-primary btn-md'
            type='button'
          >
            <i className='bi bi-pencil'></i>
          </button>
        )
      },
      width: '60px',
      ignoreRowClick: true,
      allowOverflow: true,
    },
    {
      name: 'Status',
      cell: (row) => {
        let classs =
          row.status == 'Pending'
            ? 'warning'
            : row.status == 'Activated'
              ? 'success'
              : 'danger'
        const status = row.status
        return (
          <Selector_Component
            classs={classs}
            row={row}
            onSelect={onSelect}
            status={status}
          />
        )
      },
      ignoreRowClick: true,
      allowOverflow: true,
      // button: true,
    },
  ]
  let [mydata, setMydata] = useState([])




  useEffect(() => {
    getstudents()
    getMajors()
    getCohorts()
    getSupervisors()
  }, [])

  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage)
  }

  const handlePageChange = (page) => {
    setPage(page)
  }
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false)

  function onChange(e) {
    let word = e.target.value
    const result = students.data.filter(
      (student) =>
        (student.name &&
          student.name.toLowerCase().includes(word.toLowerCase())) ||
        (student.code &&
          student.code.toLowerCase().includes(word.toLowerCase())) ||
        student.email.includes(word) ||
        student?.id == word
    )
    setMydata(result)

    if (word === '') {
      setMydata([])
      setResetPaginationToggle(!resetPaginationToggle)
    }
  }

  function exportTable() {
    let arr = mydata.length > 0 ? mydata : students.data
    arr.forEach((obj, index) => (obj.id = index + 1))
    arr.forEach((obj) => delete obj.image)
    arr.forEach((obj) => delete obj.roles)
    arr.forEach((obj) => obj.created_at = (new Date(obj?.created_at ?? '')?.toLocaleString()?.replace(',', '-') ?? ''))
    arr.forEach((obj) => (obj.cohorts = obj?.cohorts?.[0]?.name ?? ''))
    arr.forEach((obj) => (obj.majors = obj?.majors?.[0]?.name ?? ''))
    arr.forEach((obj) => (obj.supervisors = obj?.supervisors?.[0]?.name ?? ''))
    ExportCSV(arr, 'students')
  }

  // add course
  const add = (id) => {
    setStudentId(-1)
    setStudentName('')
    setStudentEmail('')
    setStudentCode('')
    setIsAdd(true)
  }

  // edit course
  const edit = (id) => {
    const result = students?.data?.find((student) => student.id === id)
    setStudentId(result?.id ?? '-1')
    setStudentName(result?.name ?? '')
    setStudentEmail(result?.email ?? '')
    setStudentCode(result?.code ?? '')
    setMajor([result?.majors?.[0] ?? ''])
    setCohort([result?.cohorts?.[0] ?? ''])
    setSupervisor([result?.supervisors?.[0] ?? ''])
    setIsAdd(true)
  }

  return (
    <>
      <div className='d-flex bd-highlight'>
        <div className='pt-2 flex-grow-1 bd-highlight'>
          <input
            type='text'
            onChange={(e) => onChange(e)}
            className='form-control w-50'
            placeholder='Search..'
            required
            aria-label=''
            aria-describedby='basic-addon1'
          />
        </div>
        <div className='p-2 bd-highlight  '>
          <button
            onClick={function () {
              add()
            }}
            className='btn text-white bg-primary btn-md col-12'
            type='button'
          >
            <i className='bi bi-plus-lg' aria-hidden='true'></i>
          </button>
        </div>
        <div className='p-2 bd-highlight'>
          <button
            onClick={function () {
              exportTable()
            }}
            className='btn   btn-md btn btn-outline-primary'
            type='button'
          >
            CSV
          </button>
        </div>
      </div>

      <DataTable
        title='Students'
        columns={columns}
        data={mydata?.length > 0 ? mydata : students.data}
        progressPending={false}
        pagination
        paginationResetDefaultPage={resetPaginationToggle}
        paginationTotalRows={
          mydata?.length > 0 ? mydata?.length : students?.data?.length
        }
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        pointerOnHover
        highlightOnHover
      />

      {/* Add & Edit Modal  */}
      <Student_Manage_Modal
        setIsAdd={setIsAdd}
        cohorts={cohorts}
        majors={majors}
        major={major}
        supervisors={supervisors}
        supervisor={supervisor}
        cohort={cohort}
        setCohort={setCohort}
        setMajor={setMajor}
        setSupervisor={setSupervisor}
        isOpen={isAdd}
        studentId={studentId}
        add={addStudent}
        edit={putstudent}
        studentName={studentName}
        studentEmail={studentEmail}
        studentCode={studentCode}
        setStudentName={setStudentName}
        setStudentEmail={setStudentEmail}
        setStudentCode={setStudentCode}
      />
    </>
  )
}

export default Student_Page
